import _flatten from 'lodash/flatten';
import { useSelector } from 'react-redux';
import { State } from 'store/onboarding';

export default function useTaskList() {
  const onboardingState: State = useSelector((state: any) => state.onboarding);

  const { checkList } = onboardingState;

  return _flatten(checkList.map(c => c.tasks));
}
